export const TIMEOUT_KEY = 'EXPIRED';
export const DEFAULT_TIMEOUT = 60;
export const TIME_CHECK_STEP = 0.1; // 1 minute check
export const TIME_CHECK_INTERVAL = 6000; // 60000 = 1 minute
